import React from "react";
// Redux Files
import { connect } from "react-redux";
import { compose } from "redux";
import { getAllUsers } from "../../actions/admin-actions";
import moment from "moment";
// Styles
import styles from "./styles/dashboard.module.scss";
// Components
import DashboardHeader from "./components/DashboardHeader";
import DashboardCanvas from "./components/DashboardCanvas";
import DashboardCard from "./components/DashboardCard";
import DashboardTableContainer from './components/DasboardTableContainer';
import UsersInformation from "./components/UsersInformation";
import { Row, Col } from "react-flexbox-grid";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLastConnection: true
    };
  }

  componentDidMount() {
    this.props.getAllUsers();
  }

  componentWillUpdate(prevProps) {}

  dateFormat = date => {
    return moment(date).toString();
  };

  downloadCSV = () => {
    const userList = this.props.usersInfo.UserList;
    let csvContent = "data:text/csv;charset=utf-8,Name,Email,Last Login\n" +userList.map(e => e.name+','+e.email+','+ e.lastConnection.slice(5)).join("\n");
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "userlist.csv");
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the data file named "my_data.csv"
  }

  changeView = (view) => {
    this.setState({
      isLastConnection: view
    })
  }

  render() {
    const { totalUsers, weeklyActiveUsers, UserList } = this.props.usersInfo;
    const { isLastConnection } = this.state;
    return (
      <section className={styles.__container}>
        <DashboardHeader title="Dashboard" isLastConnection={isLastConnection} click={this.changeView}/>
        <DashboardCanvas>
          { isLastConnection && 
          <>
            <Row>
              <Col xs={4}>
                <DashboardCard title="Registered Users" amount={totalUsers} />
              </Col>
              <Col xs={4}>
                <DashboardCard title="Weekly Active Users" amount={weeklyActiveUsers} />
              </Col>
            </Row>
            <DashboardTableContainer UserList={UserList} dateFormat={this.dateFormat} download={this.downloadCSV} />
          </>
        }
        {
          !isLastConnection && 
          <UsersInformation/>
        }
        </DashboardCanvas>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    usersInfo: state.adminReducer.usersData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllUsers: () => dispatch(getAllUsers())
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Dashboard);
